import { Grid, useMediaQuery } from "@mui/material";
import { DateField, Labeled, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { MobilityVisitType } from "utils/constants";

// each mobility type carries its own nested detail object and its own section title
const MOBILITY_DETAILS = {
  [MobilityVisitType.Training]: { title: "Допълнителни данни за обучението", source: "studyApplicationDetail" },
  [MobilityVisitType.Internship]: { title: "Данни за стажа", source: "traineeshipApplicationDetail" },
  [MobilityVisitType.BIP]: { title: "Данни за BIP", source: "bipApplicationDetail" },
};

const MobilityDetailsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  const details = MOBILITY_DETAILS[record?.type];

  if (!details || !record[details.source]) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title={details.title}
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {record.type === MobilityVisitType.Training ? (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Семестър">
                <TextField
                  source="studyApplicationDetail.semester"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Кампания">
                <TextField
                  source="studyApplicationDetail.campaignName"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
          </>
        ) : null}

        {record.type === MobilityVisitType.Internship ? (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Начало на стажа">
                <DateField
                  source="traineeshipApplicationDetail.startDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Край на стажа">
                <DateField
                  source="traineeshipApplicationDetail.endDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
          </>
        ) : null}

        {record.type === MobilityVisitType.BIP ? (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Име">
                <TextField
                  source="bipApplicationDetail.name"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Номер">
                <TextField
                  source="bipApplicationDetail.number"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Начало">
                <DateField
                  source="bipApplicationDetail.startDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <Labeled label="Край">
                <DateField
                  source="bipApplicationDetail.endDate"
                  locales="bg-BG"
                  emptyText="-"
                />
              </Labeled>
            </Grid>
          </>
        ) : null}
      </Grid>
    </>
  );
};

export default MobilityDetailsSection;
